import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import Product from '../../../models/Product';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit{
  navigationSubscription: Subscription;
  @Input() product?: Product;
  @Input() mediaUrl?: string;

  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  public status;
  ngOnInit() {
    if ((this.product as any).process_status) {
      this.status = (this.product as any).process_status.name;
    }
  }
  edit(productId) {
    this.onEdit.emit(productId);
  }
}
